module.exports = __webpack_public_path__ + "media/thanos_reverse_sound.e00730e1.mp3";